import React, { useEffect, useRef } from "react";
import IntlMessages from "components/Message/IntlMessages";
import imgBird from "assets/images/system-crash/char.png";
import logo from "assets/images/system-crash/logo.png";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { Button } from "antd";
import { Routes } from "const";
import DangerousMessage from "components/Message/DangerousMessage";
import { useDispatch, useSelector } from "react-redux";
import { NavigationBottomSelector } from "redux/selector/navigation-buttom-selector";
import { MenuSelector } from "redux/selector/menu-selector";
import { showAllMainMenu } from "redux/reducers/auth";
import useNavigateUserLanding from "components/hooks/useNavigateUserLanding";

function SystemClose({ visible, close, state }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const watchUserLeaveRef = useRef();
  const { goHome } = useNavigateUserLanding();
  const menuSet = useSelector(NavigationBottomSelector.navigationMenuSet);
  const forceHideAllMenu = useSelector(MenuSelector.forceHideAllMenu);

  useEffect(() => {
    return () => {
      if (watchUserLeaveRef.current) {
        watchUserLeaveRef.current = false;
        close();
        document.body.style.overflow = "";
      }
    };
  }, [close, location.pathname]);

  useEffect(() => {
    if (visible && !watchUserLeaveRef.current) {
      watchUserLeaveRef.current = true;
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      document.body.style.overflow = "hidden";
    }
  }, [visible]);

  function shouldShowCloseButton() {
    return [Routes.UltraHigh.Investment, Routes.History.Histories].some((pathname) => location.pathname === pathname);
  }

  function shouldShowBackToHomePageButton() {
    return forceHideAllMenu || !menuSet?.length;
  }

  function goToMainPage() {
    close();

    goHome();

    if (forceHideAllMenu) {
      dispatch(showAllMainMenu());
    }
  }

  function renderNavigateBack() {
    const showCloseBtn = shouldShowCloseButton();
    const backToHomeBtn = shouldShowBackToHomePageButton();

    if (backToHomeBtn) {
      return (
        <div className="mx-3 mt-5">
          <Button className="btn button-ktb-main w-100" onClick={goToMainPage}>
            <IntlMessages id="global.goback.to.main" />
          </Button>
        </div>
      );
    }

    if (showCloseBtn) {
      return (
        <div className="mx-3 mt-5">
          <Button className="btn button-ktb-main w-100" onClick={close}>
            <IntlMessages id="global.close" />
          </Button>
        </div>
      );
    }

    return null;
  }

  if (!visible) {
    return null;
  }

  return (
    <SystemCloseStyled>
      <div className="bg-popup">
        <div className="obj-bird">
          <img src={imgBird} alt="Bird" className="w-100" />
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="px-2 py-4">
          <div className="font-16 kt-font-b">
            <DangerousMessage.Div html={state?.message} />
          </div>
          {renderNavigateBack()}
        </div>
      </div>
    </SystemCloseStyled>
  );
}

export default SystemClose;

const SystemCloseStyled = styled.div`
  position: absolute;
  background: rgba(0, 0, 0, 0.6);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10010;

  .bg-popup {
    border-radius: 30px;
    margin-left: 5%;
    margin-right: 5%;
    text-align: center;
    width: 94%;
    height: auto;
    position: absolute;
    top: 50%;
    left: 45%;
    transform: translate(-50%, -50%);
    background: rgb(113, 207, 241);
    background: linear-gradient(
      180deg,
      rgba(113, 207, 241, 1) 0%,
      rgba(255, 255, 255, 1) 45%,
      rgba(255, 255, 255, 1) 100%
    );
  }
  .obj-bird {
    margin-top: -120px !important;
    width: 80%;
    margin: 0 auto;
  }
  .logo {
    width: 200px;
    margin-top: 20px;
  }
  .line {
    background: #f8cc46;
    width: 40px;
    height: 4px;
    margin: 20px auto;
  }
`;
